module.exports = __webpack_public_path__ + "static/img/arrow_600.614dbaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/arrow_600.png
// module id = SVFB
// module chunks = 0